import { Fragment, PropsWithChildren, ReactElement } from 'react';
import { ToastContainer, ToastContainerProps } from 'react-toastify';

import 'react-toastify/dist/ReactToastify.css';

const reactToastifyDefaultConfig: ToastContainerProps = {
  position: 'top-right',
  autoClose: 3000,
  hideProgressBar: false,
  newestOnTop: false,
  closeOnClick: true,
  rtl: false,
  pauseOnFocusLoss: true,
  draggable: true,
  pauseOnHover: true,
  theme: 'light',
};

export const ToastProvider = (props: PropsWithChildren): ReactElement => {
  return (
    <Fragment>
      <ToastContainer {...reactToastifyDefaultConfig} />
      {props.children}
    </Fragment>
  );
};